module.exports = __webpack_public_path__ + "img/pyszne.9205f43a.png";